module.exports = __webpack_public_path__ + "static/media/BikeSharing-retro1.69f3640c.pdf";